import type { ComponentType } from 'react';
import { StatCard } from './stat-card';

interface DataCardProps {
  title: string;
  value: string | number | null;
  subLabel?: string;
  trend?: number;
  icon?: ComponentType<{ className?: string }>;
  isLoading?: boolean;
  className?: string;
  format?: 'currency' | 'number' | 'percent' | 'text';
  onClick?: () => void;
}

function mapFormat(format?: DataCardProps['format']): 'currency' | 'number' | 'percent' | 'raw' {
  if (!format || format === 'text') return 'raw';
  return format;
}

/** Dashboard metric tile — thin wrapper over StatCard preserving the legacy DataCard API. */
export function DataCard({
  title,
  value,
  subLabel,
  trend,
  icon,
  isLoading,
  className,
  format,
  onClick,
}: DataCardProps) {
  const isNullish = value === null || value === undefined;

  return (
    <StatCard
      label={title}
      value={isNullish ? '—' : value}
      format={isNullish ? 'raw' : mapFormat(format)}
      icon={icon}
      helper={subLabel}
      delta={trend}
      deltaFormat="percent"
      isLoading={isLoading}
      className={className}
      onClick={onClick}
    />
  );
}
